import React, {createContext, useState, useContext} from 'react';
// import { colors } from 'resources/colors';

const ThemeContext = createContext<any>({});
const SetThemeContext = createContext<any>({});

const colors = {
  light: require('resources/themes/light').colors,
  dark: require('resources/themes/dark').colors,
};
const lightTheme = {colors: colors.light, name:'light'};
const darkTheme = {colors: colors.dark, name:'dark'};
export let themeColors = lightTheme;

export function ThemeProvider({ children }) {
  let localTheme = localStorage.getItem('userTheme');
  const userTheme = localTheme ? localTheme : 'light';
  const userColors = userTheme==='light' ? lightTheme: darkTheme;
  const [theme, setTheme] = useState(userColors);
  themeColors = theme.colors;
  function changeTheme(_theme: string) {
    if(_theme === 'light') {
      setTheme(lightTheme);
      themeColors = lightTheme;
      localStorage.setItem('userTheme', 'light');
    } else {
      setTheme(darkTheme);
      themeColors = darkTheme;
      localStorage.setItem('userTheme', 'dark');
    }

  }

  return (
    <ThemeContext.Provider value={theme}>
      <SetThemeContext.Provider value={changeTheme}>
        {children}
      </SetThemeContext.Provider>
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}

export function useSetTheme() {
  return useContext(SetThemeContext);
}
